import { ArrowUpRight, Plane, Fuel, Ship, Droplets, Cog, Flame, PackageOpen } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { presetProduct } from "./QuoteSection";

const PRODUCTS = [
  { name: "Jet A-1", note: "Aviation turbine fuel", icon: Plane },
  { name: "AGO / Diesel", note: "Automotive gas oil", icon: Fuel },
  { name: "PMS", note: "Premium motor spirit", icon: Droplets },
  { name: "Marine Fuels", note: "Bunker fuels & MGO", icon: Ship },
  { name: "Fuel Oil", note: "Industrial fuel oil", icon: Flame },
  { name: "Lubricants", note: "Industrial & marine grades", icon: Cog },
  { name: "Other Products", note: "Tell us the specification", icon: PackageOpen },
];

export default function ProductsSection() {
  return (
    <section id="products" data-testid="products-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag number="05" label="Products" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white max-w-3xl">
            Petroleum products we can <span className="text-gold">help procure.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.name} delay={0.05 * i}>
              <button
                data-testid={`product-tile-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                onClick={() => presetProduct(p.name === "Other Products" ? "Other Petroleum Product" : p.name)}
                className="group w-full text-left glass-panel rounded-xl p-7 hover:border-gold/40 hover:bg-white/[0.05] transition-all duration-500 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between">
                  <p.icon className="w-6 h-6 text-gold/80 group-hover:text-gold transition-colors duration-300" strokeWidth={1.5} />
                  <ArrowUpRight className="w-4 h-4 text-white/20 group-hover:text-gold group-hover:rotate-45 transition-all duration-300" />
                </div>
                <h3 className="font-outfit text-xl font-light text-white mt-6">{p.name}</h3>
                <p className="text-sm text-white/45 mt-1">{p.note}</p>
              </button>
            </Reveal>
          ))}

          <Reveal delay={0.35} className="sm:col-span-2">
            <div
              data-testid="products-custom-cta"
              className="h-full rounded-xl border border-gold/30 bg-gradient-to-br from-gold/10 via-transparent to-transparent p-7 flex flex-col sm:flex-row sm:items-center gap-5 justify-between"
            >
              <div>
                <h3 className="font-outfit text-xl font-light text-white">Can&rsquo;t find what you need?</h3>
                <p className="text-sm text-white/55 mt-1 max-w-md">
                  Tell us what you need and our procurement team will help identify suitable
                  supply options.
                </p>
              </div>
              <button
                data-testid="products-request-product-btn"
                onClick={() => presetProduct("Other Petroleum Product")}
                className="shrink-0 inline-flex items-center gap-2 bg-gold text-ink font-outfit font-medium text-sm rounded-full px-6 py-3 hover:bg-goldbright hover:shadow-[0_0_32px_rgba(217,164,65,0.4)] transition-all duration-300"
              >
                Request a Product
                <ArrowUpRight className="w-4 h-4" />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
